// src/Components/LanguageSwitcher/index.tsx
//
// Seletor de idioma da área do estabelecimento.
//
// Fica no menu lateral, logo acima de "Sair". Foi a posição escolhida por não
// disputar espaço com o hambúrguer, o título e o avatar no cabeçalho mobile —
// trocar de idioma é ação pontual, não precisa estar na barra superior.

import React from "react";
import { useLang, LANGS, LANG_LABEL, LANG_NAME } from "../../i18n";

export const LanguageSwitcher: React.FC = () => {
  const { lang, setLang } = useLang();

  return (
    <div
      role="group"
      aria-label="Idioma / Language"
      style={{
        display: "flex",
        gap: 6,
        margin: "0 12px 10px",
        padding: 4,
        background: "rgba(255,255,255,0.12)",
        borderRadius: 30,
      }}
    >
      {LANGS.map((opcao) => {
        const ativo = opcao === lang;

        return (
          <button
            key={opcao}
            type="button"
            onClick={() => setLang(opcao)}
            aria-pressed={ativo}
            title={LANG_NAME[opcao]}
            style={{
              flex: 1,
              padding: "7px 0",
              background: ativo ? "#fff" : "transparent",
              color: ativo ? "#00b6bc" : "#fff",
              border: "none",
              borderRadius: 30,
              fontWeight: 700,
              fontSize: 12,
              letterSpacing: 0.5,
              cursor: ativo ? "default" : "pointer",
              transition: "background 0.2s, color 0.2s",
            }}
          >
            {LANG_LABEL[opcao]}
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;